import $ from 'jquery';
import slick from 'slick-carousel';

$(document).ready(function (){

	$('.slider__list').each(function () {

		const initialSettings = {
			dots: true,
			dotsClass: 'slider__pagination',
			prevArrow: '<button type="button" class="slider__button slider__button_prev"></button>',
			nextArrow: '<button type="button" class="slider__button slider__button_next"></button>',
			appendArrows: $('<div></div>').addClass('slider__nav').insertAfter($(this)),
			lazyLoad: 'progressive'
		};

		let additionalSettings;

		if ($(this).closest('.slider').hasClass('slider_type_cards')) {
			additionalSettings = {
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: false
					}
				}]
			};
		}
		if ($(this).closest('.slider').hasClass('slider_type_thumbnails')) {
			additionalSettings = {
				dots: false,
				infinite: false,
				appendArrows: $('<div></div>').addClass('slider__nav').appendTo($(this).closest('.slider').find('.slider__header')),
				slidesToShow: 8,
				slidesToScroll: 8,
				responsive: [{
					breakpoint: 1100,
					settings: {
						slidesToShow: 7,
						slidesToScroll: 7
					}
				}, {
					breakpoint: 1000,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 6
					}
				}, {
					breakpoint: 900,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5
					}
				}, {
					breakpoint: 750,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4
					}
				}, {
					breakpoint: 650,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}, {
					breakpoint: 400,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows: false
					}
				}]
			};
		}
		if ($(this).closest('.slider').hasClass('slider_type_product')) {
			additionalSettings = {
				arrows: false
			};
		}
		if ($(this).closest('.slider').hasClass('slider_autoplay')) {
			additionalSettings = {
				autoplay: true
			};
		}
		const settings = Object.assign(initialSettings, additionalSettings);
		// console.log(additionalSettings);
		$(this).slick(settings);
	});

	$('.slider_equalized')
		.find('.slider__list')
		.on('setPosition', function () {
			$(this)
				.find('.slick-slide')
				.height('auto');
			const slickTrackHeight = $(this).find('.slick-track').height();
			$(this)
				.find('.slick-slide')
				.css('height', slickTrackHeight + 'px');
		});
});



/** WEBPACK FOOTER **
 ** ./app/blocks/slider/slider.js
 **/